import axios from 'axios';
import { toast } from 'react-toastify';

const base = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/admin`,
});

// 권한 부족 응답은 전역 토스트로 안내.
// 401(미로그인/만료) 은 useAutoRemoveAuth 가 처리하므로 여기선 건드리지 않는다.
base.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 403) {
      const raw = error.response?.data?.message;
      const message = typeof raw === 'string' ? raw : '권한이 없습니다';
      toast.error(message);
    }
    return Promise.reject(error);
  },
);

export { base };
export * as AuthApi from './auth';
export * as MeApi from './me';
export * as OrganizationApi from './organization';
export * as AdminsApi from './admins';
export * as PermissionApi from './permission';
export * as RoleApi from './role';
export * as OrgMemberApi from './org-member';
export * as UserApi from './user';
export * as AdditionalApi from './additional';
export * as FeedbackApi from './feedback';
export * as EventApi from './event';
export * as EventAdditionalApi from './event-additional';
export * as EventFeedbackApi from './event-feedback';
export * as EventScheduleApi from './event-schedule';
export * as EnrollApi from './enroll';
export * as FileServiceApi from './file-service';
export * as PartnerApi from './partner';
export * as OpenTalkApi from './open-talk';
export * as PushApi from './push';
export * as ContentsApi from './content';
export * as CollectionApi from './collection';
export * as HomeApi from './home';
export * as ContentsFileServiceApi from './contents-file-service';
export * as StickerApi from './sticker';
export * as QuickMenuApi from './quick-menu';
export * as AppRouteApi from './app-route';
export * as UserGroupApi from './user-group';
